// extracted by mini-css-extract-plugin
module.exports = {"popupWrapper":"Popup_popupWrapper__3L-6q","fadeIn":"Popup_fadeIn__27dtT","fadeOut":"Popup_fadeOut__1YIxH"};